$(function() {
  $('.oander-block--product-slider .wc-block-grid__products').slick({
    mobileFirst: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          prevArrow: '<div class="slick-prev slick-arrow"><svg><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-next slick-arrow"><svg><use xlink:href="#icon-arrow-right"></use></svg></div>',
          dots: false,
          arrows: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          swipe: false,
          prevArrow: '<div class="slick-prev slick-arrow"><svg><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-next slick-arrow"><svg><use xlink:href="#icon-arrow-right"></use></svg></div>',
          dots: false,
          arrows: true
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          swipe: false,
          prevArrow: '<div class="slick-prev slick-arrow"><svg><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-next slick-arrow"><svg><use xlink:href="#icon-arrow-right"></use></svg></div>',
          dots: false,
          arrows: true
        }
      }
    ]
  });

  $('.testimonials-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          prevArrow: '<div class="slick-prev slick-arrow"><svg><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-next slick-arrow"><svg><use xlink:href="#icon-arrow-right"></use></svg></div>',
          arrows: true
        }
      }
    ]
  });

  if($('.counter__number').length) {
    var trigger = true;
    var counter = $('.counter__number');

    $(window).scroll(function() {
        function elementScrolled(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            var elemTop = $(elem).offset().top;
            return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
        }

        if(elementScrolled(counter)) {
            if(trigger) {
              trigger = false;
              $(counter).countTo({
                formatter: function (value, options) {
                  return value.toFixed(options.decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '');
                }
              });
            }
        }
    });
  }
});
